import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBanner = () => {
  const securityFeatures = [
    {
      icon: 'Lock',
      text: 'Enkripsi End-to-End'
    },
    {
      icon: 'Database',
      text: 'Data Tersimpan Aman'
    },
    {
      icon: 'Shield',
      text: 'Perlindungan GDPR'
    },
    {
      icon: 'Eye',
      text: 'Audit Trail Lengkap'
    }
  ];

  return (
    <div className="bg-gradient-to-r from-primary/5 to-accent/5 border border-border rounded-xl p-4 md:p-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-lg bg-success/10 flex items-center justify-center">
          <Icon name="ShieldCheck" size={20} color="var(--color-success)" />
        </div>
        <div>
          <h3 className="text-sm font-semibold text-foreground">
            Keamanan Data Terjamin
          </h3>
          <p className="text-xs text-muted-foreground">
            Standar keamanan tingkat enterprise
          </p>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {securityFeatures?.map((feature, index) => (
          <div
            key={index}
            className="flex items-center gap-2 p-3 rounded-lg bg-card border border-border"
          >
            <Icon name={feature?.icon} size={16} color="var(--color-primary)" />
            <span className="text-xs text-foreground font-medium">
              {feature?.text}
            </span>
          </div>
        ))}
      </div>
      <div className="mt-4 pt-4 border-t border-border">
        <p className="text-xs text-muted-foreground text-center">
          Platform ini menggunakan protokol keamanan standar industri untuk melindungi data bisnis Anda
        </p>
      </div>
    </div>
  );
};

export default SecurityBanner;